function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M328 2430 c-45 -14 -83 -41 -108 -78 -20 -29 -25 -48 -25 -102 0 -79 26 -125 90 -162 l40 -23 1165 -3 1164 -2 51 25 c73 36 100 81 100 165 0 84 -27 129 -99 165 l-50 25 -1150 -1 c-633 0 -1163 -4 -1178 -9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328 1680 c-45 -14 -83 -41 -108 -78 -20 -29 -25 -48 -25 -102 0 -84 27 -129 99 -165 l50 -25 1156 0 1156 0 50 25 c72 36 99 81 99 165 0 84 -27 129 -99 165 l-50 25 -1150 -1 c-633 0 -1163 -4 -1178 -9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294 915 c-72 -36 -99 -81 -99 -165 0 -84 27 -129 99 -165 l50 -25 1156 0 1156 0 50 25 c72 36 99 81 99 165 0 84 -27 129 -99 165 l-50 25 -1156 0 -1156 0 -50 -25z"
}));

var SvgHamburgerMenu = function SvgHamburgerMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHamburgerMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburger_menu.dd053695.svg";
export { ForwardRef as ReactComponent };